// "N mensajes no se enviaron · Ver · Reintentar todos · Eliminar" — the conversation's own
// admission with every move a person can make about it (port of
// ios/Sources/Views/UndeliveredStripView.swift; Android `UndeliveredStrip`). The words that say a
// retry is running sit in the sentence's row; the actions on their own row (three labels and a
// count do not fit beside each other on a phone). «Eliminar» is the app's armed delete: the first
// tap turns it into the question, the second does it, and it disarms itself after 4 s.
import { useEffect, useState } from 'react';
import { data } from '../../../bridge/client';
import { UndeliveredBanner } from '../../../core/undeliveredBanner';
import { t, tf } from '../../../i18n/i18n';
import './undelivered.css';

/** UndeliveredStripMetrics.armedNanos / Kotlin DELETE_ARMED_MILLIS. */
export const ARMED_MS = 4000;

export function UndeliveredStrip({ channelId, failedCount, onView }: { channelId: string; failedCount: number; onView(postId: string): void }) {
  const [retrying, setRetrying] = useState(false);
  const [armed, setArmed] = useState(false);
  const state = UndeliveredBanner.decide(failedCount, 0, retrying);
  useEffect(() => {
    if (!armed) return;
    const id = setTimeout(() => setArmed(false), ARMED_MS);
    return () => clearTimeout(id);
  }, [armed]);
  // Losing the right to press it also disarms it (coming back from a retry to a half-pressed delete).
  useEffect(() => {
    if (!state.canDiscard) setArmed(false);
  }, [state.canDiscard]);
  if (!state.isVisible) return null;

  const retryAll = async () => {
    if (!state.canRetry) return;
    setRetrying(true);
    try {
      await data.call('retryAllFailed', channelId);
    } finally {
      // Whatever happened, the button comes back: leaving it disabled would strand the messages.
      setRetrying(false);
    }
  };

  return (
    <div className="undelivered-strip" role="alert">
      <div className="undelivered-line">
        <span className="undelivered-dot" aria-hidden="true" />
        <span className="undelivered-text">{state.failedCount === 1 ? t('channel.undeliveredOne') : tf('channel.undeliveredMany', state.failedCount)}</span>
        {state.isRetrying ? <span className="undelivered-retrying">{t('channel.undeliveredRetrying')}</span> : null}
      </div>
      <div className="undelivered-actions">
        <button type="button" disabled={!state.canView} onClick={() => void data.call('oldestFailedId', channelId).then((id) => id && onView(id))}>
          {t('channel.undeliveredView')}
        </button>
        <button type="button" className="accent" disabled={!state.canRetry} onClick={() => void retryAll()}>
          {t('channel.undeliveredRetryAll')}
        </button>
        <span className="spacer" />
        <button
          type="button"
          className={`danger${armed ? ' armed' : ''}`}
          disabled={!state.canDiscard}
          onClick={() => {
            if (armed) {
              setArmed(false);
              void data.call('discardAllFailed', channelId);
            } else setArmed(true);
          }}
        >
          {armed ? t('channel.undeliveredDiscardConfirm') : t('channel.undeliveredDiscard')}
        </button>
      </div>
    </div>
  );
}
